export default "__VITE_ASSET__Dt6fX2ba__"